import {ModuleRouteManifest} from '../types'

export const courseExamScheduleRouteManifest: ModuleRouteManifest = {
  code: 'course-exam-schedule',
  privateRoutes: [
    'exam-scheduler',
    'course-scheduler',
    'department-course-scheduler',
    'department-course-schedule',
    'university-course-scheduler',
    'university-course-schedule',
    'my-student-schedule',
    'my-instructor-schedule',
    'my-exam-schedule',
    'e-exam/:examSeatAssignmentId',
    'my-exam-duty-archive',
    'exam-summary',
    'department-exam-status',
    'exam-schedule-list',
    'assignment-creator',
    'faculty-availability',
    'manage-swap-requests',
    'manage-makeup-requests',
    'examperiod/*',
    'exam-rules/*',
    'timeslot/*',
    'teachingassignment/*',
    'assignmentrole/*',
    'assignmentrule/*',
    'teachingassignmentslot/*',
    'building/*',
    'organizationassignment/*',
    'classroom/*',
    'organizationclassroom/*',
    'course-schedule-classroom/*',
    'facultyavailability/*',
    'examseatassignment/*',
  ],
}
